export const TrueLayerDocumentRequirementContentUK = () => {
  return (
    <ul>
      <li>
        <p>
          We’re{' '}
          <a
            href="https://www.fca.org.uk/about/what-we-do/the-fca"
            target="_blank"
            rel="noopener noreferrer"
          >
            FCA regulated
          </a>{' '}
          which means we can use <span>Open banking</span>. Open banking with
          TrueLayer is a secure way to share your account information without
          sharing your password.{' '}
          <a
            href="https://truelayer.com/openbanking/what-is-open-banking/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Learn more
          </a>
        </p>
      </li>
      <li>
        Your transactions must cover the stated period and be from the
        account(s) where the majority of your business revenue is generated.
      </li>
    </ul>
  );
};
